import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LandingPage from '../pages/Landing';
import SignUpPage from '../pages/SignUp';
import LoginPage from '../pages/Login';
import NewCrawlPage from '../pages/NewCrawl';
import LeadsPage from '../pages/Leads';
import CrawlsPage from '../pages/Crawls';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/landing" element={<LandingPage />} />
    <Route path="/sign-up" element={<SignUpPage />} />
    <Route path="/SignUp" element={<SignUpPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/new-crawl" element={<NewCrawlPage />} />
    <Route path="/NewCrawl" element={<NewCrawlPage />} />
    <Route path="/leads" element={<LeadsPage />} />
    <Route path="/crawls" element={<CrawlsPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRoutes;
